var _circle, _path, _circle2, _path2, _circle3, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWidgetLivenessSteps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 18,
    viewBox: "0 0 233 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.25313,
    cy: 9.25313,
    r: 7.75313,
    stroke: "#080917"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71454 12.4766H11.1225V6.87656H9.75454L7.82654 8.20456V9.70856L9.71454 8.32456V12.4766Z",
    fill: "#080917"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.544,
    cy: 9.25313,
    r: 7.75313,
    stroke: "#080917"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.191 11.544V12H118.631V10.904H115.775C115.823 10.696 116.039 10.504 116.671 10.192L117.303 9.912C118.279 9.488 118.799 8.968 118.799 8.056C118.799 7 118.087 6.288 116.623 6.288C114.855 6.288 114.375 7.312 114.271 8.248L115.695 8.32C115.719 7.72 116.063 7.416 116.583 7.416C117.071 7.416 117.335 7.68 117.335 8.096C117.335 8.52 117.071 8.76 116.327 9.088L115.719 9.368C114.751 9.816 114.191 10.432 114.191 11.544Z",
    fill: "#080917"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.247,
    cy: 9.25313,
    r: 7.75313,
    stroke: "#080917"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.007 12.112C225.303 12.112 226.303 11.6 226.303 10.408C226.303 9.744 225.991 9.272 225.199 9.088C225.847 8.88 226.207 8.424 226.207 7.824C226.207 6.984 225.495 6.288 224.071 6.288C222.759 6.288 221.863 6.864 221.679 8.16L223.103 8.24C223.175 7.68 223.479 7.408 223.999 7.408C224.455 7.408 224.751 7.616 224.751 8.04C224.751 8.464 224.471 8.696 223.927 8.696H223.487V9.608H223.967C224.519 9.608 224.815 9.84 224.815 10.28C224.815 10.776 224.447 10.992 223.959 10.992C223.391 10.992 223.063 10.696 222.999 10.016L221.647 10.088C221.727 11.432 222.495 12.112 224.007 12.112Z",
    fill: "#080917"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0935 9.25391H108.291",
    stroke: "#6FCBD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.797 9.25391H215.994",
    stroke: "#080917"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4550_58577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 17.301C13.5855 17.301 17.3028 13.5837 17.3028 8.99817C17.3028 4.41263 13.5855 0.695312 9 0.695312C4.41446 0.695312 0.697144 4.41263 0.697144 8.99817C0.697144 13.5837 4.41446 17.301 9 17.301Z",
    fill: "#6FCBD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18C4.0378 18 0 13.9629 0 9C0 4.0378 4.0378 0 9 0C13.9629 0 18 4.0378 18 9C18 13.9629 13.9629 18 9 18ZM9 1.39426C4.80604 1.39426 1.39426 4.80604 1.39426 9C1.39426 13.194 4.80604 16.6057 9 16.6057C13.194 16.6057 16.6057 13.1933 16.6057 9C16.6057 4.80604 13.194 1.39426 9 1.39426Z",
    fill: "#6FCBD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91245 12.3097C7.72563 12.3097 7.54714 12.2351 7.41538 12.1013L4.84296 9.48704C4.57317 9.21237 4.57665 8.77179 4.85133 8.5013C5.126 8.23221 5.56728 8.23499 5.83707 8.50967L7.89224 10.5983L12.1441 5.91563C12.4041 5.63051 12.8447 5.6103 13.1284 5.86824C13.4135 6.12688 13.4344 6.56746 13.1758 6.85328L8.42833 12.0817C8.29938 12.224 8.11812 12.3062 7.92641 12.3104C7.92152 12.3097 7.91734 12.3097 7.91245 12.3097Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4550_58577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetLivenessSteps);
export default __webpack_public_path__ + "static/media/widget-liveness-steps.d37cc54ed8c86069c509d9de41fcb996.svg";
export { ForwardRef as ReactComponent };